import { useMutation } from "services/Client";
import get from "lodash/get";
import { QUESTION_OPTION_GET_MANY } from "services/Client/schemas/queries/questionOption";
import { useNotification } from "hooks";

export default function useDeleteQuestionOption() {
  const notification = useNotification();
  const { mutate } = useMutation({
    event: "questionOption.delete",
    update: ({ data: { delete_question_option_by_pk } }, cache) => {
      const questionId = get(delete_question_option_by_pk, "questionId");

      const prevData = cache.readQuery({
        query: QUESTION_OPTION_GET_MANY,
        variables: {
          where: { questionId: { _eq: questionId } },
          order_by: { order: "asc" },
        },
      });

      const newData = prevData.question_option.filter(
        (question_option) =>
          question_option.id !== delete_question_option_by_pk.id
      );
      const data = {
        question_option: [...newData],
      };
      cache.writeQuery({
        query: QUESTION_OPTION_GET_MANY,
        data,
        variables: {
          where: { questionId: { _eq: questionId } },
          order_by: { order: "asc" },
        },
      });
    },
    onCompleted: () => {
      notification.success({
        message: "Delete Successful",
      });
    },
  });
  return mutate;
}
